import React, { useEffect, useRef, useState } from "react";
import EdModal from "../../generic/edModal";
import TocDropdown from "../../generic/tocDropdown";
import { IListObj } from "../../types/genericTypes";
import { ClevertapService } from "../../service/clevertapService";
import { NetcoreService } from "../../service/netcoreService";
import urlConfig, { config } from "../../../config/domain";
import { FinalPopupScreen } from "../generic/finalPopupScreeen";
import { useQuery } from "../../service/urlHelper";
import {
  GetCKYCValidation,
  getDematAcctValidation,
  GetDepositoryDetails,
  getEquityDormantClientCategoryValidation,
} from "../../service/serviceRequest/srApiService";
import Loader, { PageLoader } from "../../generic/loader";
import { createBrowserHistory } from "history";
import { getAccData,getinvAccDet } from "../../service/login/loginService";
import deviceName from "../../utils/deviceName";
import browserName from "../../utils/browserName";
import {
  BankModificationSteps,
  AddrModificationSteps,
  SegmentActivationSteps,
  SegmentDeactivationSteps,
} from "./constant";
import { StaticPopup } from "../../generic/staticPopup";
import moment from "moment";
import { Idevice } from "../../types/device";
import DeviceContext from "../../service/indentifyDevice";
import jwt_decode from "jwt-decode";
let invOnlyAcc = getinvAccDet();
var overflowBtnDropdownOptions: Array<any> = [];

overflowBtnDropdownOptions.push(
  {
    value: "/clientarea/service-request/smtf",
    display: "NRML-SMTF Funds Movement Preference",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/segment-deactivation",
    display: "Segment Deactivation",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/early-payin",
    display: "Early Payin – During Market Hours/EOD",
    isBlocked: false,
  },
);

var optionsForSingleHolder = [
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=7",
    display: "New DIS Booklet",
    isBlocked: false,
  },
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=8",
    display: "DP Scheme Change",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/email-mobile-modification",
    display: "Email & Mobile Modification",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/fatcaUpdate",
    display: "FATCA Update",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/bank-modification",
    display: "Bank Modification",
    isBlocked: false,
  },
  {
    value:
      config.rootUrl +
      "clientarea/servicerequest?create-request&selectedVal=10",
    display: "Income Declaration",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/segment-activation",
    display: "Segment Activation",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/account-closure",
    display: "Account Closure",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/address-modification",
    display: "Address Modification",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/nomination",
    display: "Nomination",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/ddpi",
    display: "DDPI",
    isBlocked: false,
  },
  // {
  //   value: "/clientarea/service-request/ckyc-update",
  //   display: "CKYCUpdate ",
  //   isBlocked: false,
  // },
];
var optionsForNonInd = [
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=7",
    display: "New DIS Booklet",
    isBlocked: false,
  },
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=8",
    display: "DP Scheme Change",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/email-mobile-modification",
    display: "Email & Mobile Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/fatcaUpdate",
    display: "FATCA Update",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/bank-modification",
    display: "Bank Modification",
    isBlocked: true,
  },
  {
    value:
      config.rootUrl +
      "clientarea/servicerequest?create-request&selectedVal=10",
    display: "Income Declaration",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/segment-activation",
    display: "Segment Activation",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/account-closure",
    display: "Account Closure",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/address-modification",
    display: "Address Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/nomination",
    display: "Nomination",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/ddpi",
    display: "DDPI",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/ckyc-update",
    display: "CKYCUpdate ",
    isBlocked: true,
  },
];
var optIndMissDp = [
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=7",
    display: "New DIS Booklet",
    isBlocked: true,
  },
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=8",
    display: "DP Scheme Change",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/email-mobile-modification",
    display: "Email & Mobile Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/fatcaUpdate",
    display: "FATCA Update",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/bank-modification",
    display: "Bank Modification",
    isBlocked: true,
  },
  {
    value:
      config.rootUrl +
      "clientarea/servicerequest?create-request&selectedVal=10",
    display: "Income Declaration",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/segment-activation",
    display: "Segment Activation",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/account-closure",
    display: "Account Closure",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/address-modification",
    display: "Address Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/nomination",
    display: "Nomination",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/ddpi",
    display: "DDPI",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/ckyc-update",
    display: "CKYCUpdate ",
    isBlocked: true,
  },
];
var optIndJointHold = [
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=7",
    display: "New DIS Booklet",
    isBlocked: false,
  },
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=8",
    display: "DP Scheme Change",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/email-mobile-modification",
    display: "Email & Mobile Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/fatcaUpdate",
    display: "FATCA Update",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/bank-modification",
    display: "Bank Modification",
    isBlocked: true,
  },
  {
    value:
      config.rootUrl +
      "clientarea/servicerequest?create-request&selectedVal=10",
    display: "Income Declaration",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/segment-activation",
    display: "Segment Activation",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/account-closure",
    display: "Account Closure",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/address-modification",
    display: "Address Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/nomination",
    display: "Nomination",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/ddpi",
    display: "DDPI",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/ckyc-update",
    display: "CKYCUpdate ",
    isBlocked: true,
  },
];
var optIndOutsideDp = [
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=7",
    display: "New DIS Booklet",
    isBlocked: true,
  },
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=8",
    display: "DP Scheme Change",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/email-mobile-modification",
    display: "Email & Mobile Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/fatcaUpdate",
    display: "FATCA Update",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/bank-modification",
    display: "Bank Modification",
    isBlocked: true,
  },
  {
    value:
      config.rootUrl +
      "clientarea/servicerequest?create-request&selectedVal=10",
    display: "Income Declaration",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/segment-activation",
    display: "Segment Activation",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/account-closure",
    display: "Account Closure",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/address-modification",
    display: "Address Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/nomination",
    display: "Nomination",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/ddpi",
    display: "DDPI",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/ckyc-update",
    display: "CKYCUpdate ",
    isBlocked: false,
  },
];
var optNRI = [
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=7",
    display: "New DIS Booklet",
    isBlocked: false,
  },
  {
    value:
      config.rootUrl + "clientarea/servicerequest?create-request&selectedVal=8",
    display: "DP Scheme Change",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/email-mobile-modification",
    display: "Email & Mobile Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/fatcaUpdate",
    display: "FATCA Update",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/bank-modification",
    display: "Bank Modification",
    isBlocked: true,
  },
  {
    value:
      config.rootUrl +
      "clientarea/servicerequest?create-request&selectedVal=10",
    display: "Income Declaration",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/segment-activation",
    display: "Segment Activation",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/account-closure",
    display: "Account Closure",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/address-modification",
    display: "Address Modification",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/nomination",
    display: "Nomination",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/ddpi",
    display: "DDPI",
    isBlocked: true,
  },
  {
    value: "/clientarea/service-request/ckyc-update",
    display: "CKYCUpdate ",
    isBlocked: true,
  },
];

var optionsForInvestmentAcc = [
{
    value: "/clientarea/service-request/email-mobile-modification",
    display: "Email & Mobile Modification",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/address-modification",
    display: "Address Modification",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/bank-modification",
    display: "Bank Modification",
    isBlocked: false,
  },
  {
    value: "/clientarea/service-request/nomination",
    display: "Nomination",
    isBlocked: false,
  },
  {
    value:
      config.rootUrl +
      "clientarea/servicerequest?create-request&selectedVal=10",
    display: "Income Declaration",
    isBlocked: false,
  },
];

const msgForBlockSRByCategory: {
  [key: string]: any;
} = {
  "Individual Outside DP":
    " You are having an external demat account linked to your trading account. This feature is available only for Resident Individual clients having both trading and demat account with us. Please reach out to your RM or call servicing team 18001023335 for further assistance.",
  "Individual Missing DP Details":
    "It seems you do not have a demat account linked to your trading account. You need to have a demat account linked to your trading account to use this feature. Please reach out to your RM or call servicing team 18001023335.",
  "Individual Joint Holder":
    "You are having a joint holder demat account. This feature is available only for Resident Individual Single demat account holders. Please reach out to your RM or call servicing team 18001023335.",
  NRI: "You are an NRI customer. This feature is available only for Resident Individual clients having both trading and demat account with us. Please reach out to your RM or call servicing team 18001023335.",
  "Non Individual":
    "Your account is of non-individual category. This feature is available only for Resident Individual clients having both trading and demat account with us. Please reach out to your RM or call servicing team 18001023335.",
};

var totalStage = [
  "Profile Details",
  "Address Details",
  "Bank Details",
  window.localStorage.getItem("digiAuthKey") ? "Document Upload ": "Document Upload & Video IPV",
  "E-sign",
];
const device: String = deviceName();
const devicetype: Idevice = DeviceContext();
const deviceType: Idevice = DeviceContext();

export const SRLayout = (props: any) => {
  let source = useQuery().get("source");
  if (source) window.localStorage.setItem("source", source);
  else source = window.localStorage.getItem("source");
  const RedirectnSource = source;
  const incomeDropdown = useQuery().get("incomeConsent");
  const addressConsent = useQuery().get("consent");
  const consentType = useQuery().get("consentType");
  const queryObject = useQuery();
  const history = createBrowserHistory({ forceRefresh: true });
  const compDet = useRef();
  const [showFinalPopup, setShowFinalPopup] = useState(false);
  const [poaFlagLoader, setPOAFlagLoader] = useState<any>(true);
  const [popupData, setPopupData] = useState<any>({});
  const [srDropdown, setSrDropdown] = useState(false);
  const [showModel, setShowModel] = useState(true);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [btnText, setBtnText] = useState("Submit");
  const [showFooter, setShowFooter] = useState(false);
  const [currentStage, setCurrentStage] = useState(1);
  const [rightSideSec, setRightSideSec] = useState<any>();
  const [accountCategory, setAccountCategory] = useState<string>("");
  const [parentLoader, setParentLoader] = useState<boolean>(false);
  const [SROptions, setSROptions] = useState<Array<IListObj>>([]);
  const [stepsPopup, setStepsPopup] = useState(false);
  const [srType, setSrType] = useState<string>("");

  const clevertapService = new ClevertapService();
  const netcoreService = new NetcoreService();

  const consentList = getAccData("cnsntLst")
    ? getAccData("cnsntLst")
    : JSON.parse(localStorage.getItem("cnsntLst") || "{}");
  const initalValueSet = () => {
    setPOAFlagLoader(true);
    if (window.location.href.includes("account-reactivation")) {
      overflowBtnDropdownOptions.push(
        {
          value: "/clientarea/service-request/open",
          display: "Select Request Type",
        },
        {
          value: "/clientarea/service-request/account-reactivation",
          display: "Account Reactivation",
        }
      );

      //Adding this line to fix this removing delay in update dropdown.
      setSROptions(overflowBtnDropdownOptions);
    }
    if (window.location.href.includes("ckyc-update")) {
      overflowBtnDropdownOptions.push(
        {
          value: "/clientarea/service-request/open",
          display: "Select Request Type",
        },
        {
          value: "/clientarea/service-request/ckyc-update",
          display: "CKYC Update",
        }
      );
      //Adding this line to fix this removing delay in update dropdown.
      setSROptions(overflowBtnDropdownOptions);
    }
  };
  const setCkycOption = async () => {
    let ckycResp = await GetCKYCValidation();
    if (typeof ckycResp == "string" && ckycResp.match("No")) {
      overflowBtnDropdownOptions.push({
        value: "/clientarea/service-request/ckyc-update",
        display: "CKYC Update",
        isBlocked: false,
      });
    }
  };

  const setOptForNonImpersUser = async () => {
    const clientCategoryRes = await getEquityDormantClientCategoryValidation();
    setAccountCategory(clientCategoryRes[0]?.AccountCategory);
    if (
      clientCategoryRes &&
      clientCategoryRes.length > 0 &&
      clientCategoryRes[0].AccountCategory === "Individual SingleHolder"
    ) {
      overflowBtnDropdownOptions.push(...optionsForSingleHolder);
    } else if (
      clientCategoryRes &&
      clientCategoryRes.length > 0 &&
      clientCategoryRes[0].AccountCategory === "NRI"
    ) {
      overflowBtnDropdownOptions.push(...optNRI);
    } else if (
      clientCategoryRes &&
      clientCategoryRes.length > 0 &&
      clientCategoryRes[0].AccountCategory === "Individual Missing DP Details"
    ) {
      overflowBtnDropdownOptions.push(...optIndMissDp);
    } else if (
      clientCategoryRes &&
      clientCategoryRes.length > 0 &&
      clientCategoryRes[0].AccountCategory === "Individual JointHolder"
    ) {
      overflowBtnDropdownOptions.push(...optIndJointHold);
    } else if (
      clientCategoryRes &&
      clientCategoryRes.length > 0 &&
      clientCategoryRes[0].AccountCategory === "Individual Outside DP"
    ) {
      overflowBtnDropdownOptions.push(...optIndOutsideDp);
    } else if (
      clientCategoryRes &&
      clientCategoryRes.length > 0 &&
      clientCategoryRes[0].AccountCategory === "Non Individual"
    ) {
      overflowBtnDropdownOptions.push(...optionsForNonInd);
    }
    else if(invOnlyAcc){
      // overflowBtnDropdownOptions = [];
      overflowBtnDropdownOptions.push(...optionsForInvestmentAcc);
      overflowBtnDropdownOptions =  overflowBtnDropdownOptions.filter(
        (ele: any) =>
          [
            "Email & Mobile Modification",
            "Address Modification",
            "Bank Modification",
            "Nomination",
            "Income Declaration",
          ].includes(ele.display)
      );
    }
    let response = await GetDepositoryDetails();

    if (getAccData("accTyp") === "CO") {
      overflowBtnDropdownOptions = overflowBtnDropdownOptions.filter(
        (ele: any) =>
          ![
            "Income Declaration",
            // "Segment Activation",
            "New DIS Booklet",
            "DP Scheme Change",
          ].includes(ele.display)
      );
    }
    if (response && response.dPIdField && response.dPAccountNumberField) {
      window.sessionStorage.setItem("dpId", response.dPIdField);
      let check_val = response.dPIdField + response.dPAccountNumberField;
      let AccountCheck = await getDematAcctValidation(check_val);
      if (!AccountCheck) {
        overflowBtnDropdownOptions = overflowBtnDropdownOptions.filter(
          (ele: any) => {
            return (
              ele.display !== "New DIS Booklet" &&
              ele.display !== "DP Scheme Change"
            );
          }
        );
      }
    }
  };
  useEffect(() => {
    if (SROptions.length > 1) setPOAFlagLoader(false);
  }, [SROptions]);

  async function blockSR() {
    initalValueSet();
    await setCkycOption();
    const ImpersonateUser = window.localStorage.getItem("isImpersonated")
      ? true
      : false;
    if (!ImpersonateUser) {
      await setOptForNonImpersUser();
    }
    if (
      consentList &&
      consentList.length > 0 &&
      consentList.find((list: any) => ["accReact"].includes(list.name))
    ) {
      overflowBtnDropdownOptions = overflowBtnDropdownOptions.filter(
        (ele: any) =>
          ![
            "Email & Mobile Modification",
            "Address Modification",
            "FATCA Update",
            "CKYC Update",
            "Income Declaration",
          ].includes(ele.display)
      );
    }

    overflowBtnDropdownOptions = overflowBtnDropdownOptions.sort(
      (a: any, b: any) => {
        if (a.key == b.key) return 0;
        if (a.key == "Select Request Type") return -1;
        if (b.key == "Select Request Type") return 1;

        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        return 0;
      }
    );
    overflowBtnDropdownOptions.splice(0, 0, {
      value: "/clientarea/service-request/open",
      display: "Select Request Type",
    });
    setSROptions(overflowBtnDropdownOptions);
  }

  function redirectToAngularSites(value: any) {
    setPOAFlagLoader(true);
    window.location.href = value;
  }

  React.useEffect(() => {
    setSrType(window.location.href.split("/")[5])
    window.document.body.style.overflow = "hidden";
    blockSR();
  }, []);
  React.useEffect(() => {
    if (!showModel) {
      props.history.push("/clientarea/service-request");
      window.location.reload();
    }
  }, [showModel]);

  React.useEffect(() => {
    if (currentStage === 6) {
      totalStage.push("Pending Debit");
    }
  }, [currentStage]);

  const handleSubmit = (val: any, obj: any) => {
    setShowFinalPopup(true);
    setPopupData(obj);
  };
  const onSubmit = () => {
    var comp: any = compDet?.current;
    comp.submitData(btnText);
  };

  const getStepsHeader = () => {
    var header = null;
    if (window.location.href.includes("address-modification"))
      header = AddrModificationSteps.heading;
    else if (window.location.href.includes("bank-modification"))
      header = BankModificationSteps.heading;
    else if (window.location.href.includes("segment-deactivation"))
      header = SegmentDeactivationSteps.heading;
    else if (window.location.href.includes("segment-activation"))
      header = SegmentActivationSteps.heading;
    return header;
  };
  const triggerClvrTap = (type: string) => {
    var data = {
      EventName: "Successful_SR",
      InitiationElement: "SrLayout_Popup_Close",
      InitiationScreen: window.location.pathname,
      LoginType: "Traditional",
      SrType: type,
      currentTime: moment().format("DD/MM/YYYY HH:mm:ss"),
      Platform: window.localStorage.getItem("lgnSrc")
        ? window.localStorage.getItem("lgnSrc")
        : deviceType.isMobile
        ? "Website_Mobile"
        : "Website_Desktop",
    };
    var attributesList = {
      event_name: "successful_sr",
      initiation_element: "SrLayout_Popup_Close",
      initiation_screen: window.location.pathname,
      login_type: "Traditional",
      sr_type: type,
      current_time: moment().format("DD/MM/YYYY HH:mm:ss"),
      platform: window.localStorage.getItem("lgnSrc")
        ? window.localStorage.getItem("lgnSrc")
        : deviceType.isMobile
        ? "Website_Mobile"
        : "Website_Desktop",
    };
    clevertapService.pushEvent(data);
    netcoreService.netcoreEventFire(attributesList.event_name, attributesList);
  };
  const getSRname = function(srType: string){
    switch(srType){
      case "nomination": return "nominee";
      case "emailMob": 
      case "emailMobile": 
      case "accReact": 
      case "addressModification":
      case "address": return "accReact";
      default: return "";
    }
  }
  const getStepsContent = () => {
    var content = null;
    if (window.location.href.includes("address-modification"))
      content = AddrModificationSteps.content;
    else if (window.location.href.includes("bank-modification"))
      content = BankModificationSteps.content;
    else if (window.location.href.includes("segment-deactivation"))
      content = SegmentDeactivationSteps.content;
    else if (window.location.href.includes("segment-activation"))
      content = SegmentActivationSteps.content;
    return content;
  };

  function ModalBody(): React.ReactElement {
    if (showFinalPopup) {
      return (
        <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup">
          <div className="modal-content top-brdr-block">
            <div className="modal-body">
              <div>
                <a
                  role="button"
                  href={
                    RedirectnSource == "onep-sr"
                      ? config.onePlatformBase + "service-request"
                      : config.rootUrl + "clientarea/servicerequest"
                  }
                  title="Close"
                  className="cancel"
                  onClick={() => {
                    let nomineePopup = localStorage.getItem("mandatePopup");
                    if (nomineePopup == "nominee")
                      localStorage.removeItem("mandatePopup");
                    let consentList: any = localStorage.getItem("consentList");
                    consentList = JSON.parse(consentList);
                    if(consentList && consentList.length > 0){
                      if(consentList[0].name === getSRname(popupData.type)){
                        consentList.shift();
                        consentList.length > 0 
                        ? localStorage.setItem("consentList",consentList)
                        : localStorage.removeItem("consentList");
                      }
                    }
                    if (
                      popupData?.popupType &&
                      popupData.popupType === "Success"
                    )
                      triggerClvrTap(popupData.type?.replace(" ", "_"));
                  }}
                >
                  <i className="edel-icon-close"></i>
                </a>
              </div>
              <div>
                <FinalPopupScreen popupData={popupData} />
              </div>
            </div>
          </div>
        </div>
      );
    } else
      return (
        <>
          <div
            className={
              "modal-dialog modal-dialog-centered common-modal-deisgn" +
              (device &&
              device === "iPhone" &&
              (browserName().browserName === "Chrome" ||
                browserName().browserName === "Safari")
                ? " modal-dialog-ios"
                : "")
            }
          >
            <div className="modal-content top-brdr-block">
              <div className="modal-header">
                <h4 className="modal-title">New Service Request</h4>
                {!(
                  currentStage !== 5 &&
                  ((consentType &&
                    (consentType?.includes("email") ||
                      consentType?.includes("nominee") ||
                      consentType?.includes("mobile") ||
                      consentType?.includes("emailMob"))) ||
                    addressConsent?.includes("Change of Address"))
                ) && (
                  <a
                    role="button"
                    href={
                      RedirectnSource == "onep-sr"
                        ? config.onePlatformBase + "service-request"
                        : config.rootUrl + "clientarea/servicerequest"
                    }
                    title="Close"
                    onClick={() => {
                      window.localStorage.removeItem("digie");
                      window.localStorage.removeItem("digieResubmit");
                      window.localStorage.removeItem("rejectFlow");
                      window.localStorage.removeItem("srId");
                      window.localStorage.removeItem("");
                    }}
                    className="cancel"
                  >
                    <i className="edel-icon-close"></i>
                  </a>
                )}
              </div>
              {(window.location.href.includes("account-closure") ||
              window.location.href.includes("ddpi")
                ? parentLoader
                : window.location.href.includes("bank-modification")
                ? poaFlagLoader || parentLoader
                : poaFlagLoader) && (
                <div className="pageLoader">
                  <PageLoader size={50} color="blue"></PageLoader>
                </div>
              )}
              {
                <form action="" className="common-modal__form">
                  <div
                    className={
                      "modal-body scrollableModal" +
                      (window.location.href.includes(
                        "email-mobile-modification"
                      )
                        ? " pb-0"
                        : "") +
                      (window.location.href.includes("nomination") ||
                      (window.location.href.includes("account-closure") &&
                        showFooter)
                        ? " nonimation-modal-body"
                        : "")
                    }
                    id="custom_scrollBar"
                    tabIndex={0}
                  >
                    <div className="force-overflow"></div>

                    <div className="custom--row progressbar_row">
                      <div
                        className={`form-field custom-col noLeftPAdding ${
                          rightSideSec ? " mb-10 mb-mobile" : ""
                        }`}
                      >
                        <label className="input-label">Request for</label>

                        <TocDropdown
                          selectedValue={
                            SROptions.length > 0
                              ? SROptions.find(
                                  (value: any) =>
                                    value.value === props.location.pathname
                                )
                                ? props.location.pathname
                                : SROptions && SROptions[0].value
                              : ""
                          }
                          dropdownOptions={
                            !props.location.pathname.includes("open")
                              ? SROptions?.filter((ele: any, i: any) => {
                                  return i !== 0;
                                })
                              : SROptions
                          }
                          onSelect={(selVal: any) => {
                            if (selVal) {
                              SROptions.find((value: any) => {
                                if (value.value === selVal) {
                                  if (value.isBlocked) {
                                    handleSubmit("srBlockedErr", {
                                      headerText:
                                        msgForBlockSRByCategory.hasOwnProperty(
                                          accountCategory
                                        )
                                          ? msgForBlockSRByCategory[
                                              accountCategory
                                            ]
                                          : "This option is available to Individual category of customers. Please reach out to your RM or call servicing team on 18001023335.",
                                    });
                                  } else {
                                    console.log("else");
                                    if (selVal.includes(config.rootUrl))
                                      redirectToAngularSites(selVal);
                                    else props.history.push(selVal);
                                  }
                                }
                              });
                              var attributesList = {
                                event_name: "create_service_request",
                                initiation_screen: window.location.pathname,
                                login_type: "Traditional",
                                sr_type: srType,
                                current_time: moment().format("DD/MM/YYYY HH:mm:ss"),
                                platform: window.localStorage.getItem("lgnSrc")
                                  ? window.localStorage.getItem("lgnSrc")
                                  : devicetype.isMobile
                                  ? "Website_Mobile"
                                  : "Website_Desktop",
                              };
                              netcoreService.netcoreEventFire(attributesList.event_name, attributesList);
                            }
                            setRightSideSec("");
                          }}
                          disabled={
                            incomeDropdown === "incomeSRDropDown" ||
                            consentType?.includes("email") ||
                            consentType?.includes("nominee") ||
                            consentType?.includes("mob")
                              ? true
                              : srDropdown
                          }
                          isSearchable={false}
                        />
                      </div>
                      {rightSideSec && (
                        <div
                          className={`form-field custom-col noLeftPAdding ${
                            rightSideSec ? " space-mb-0" : ""
                          }`}
                        >
                          {rightSideSec}
                        </div>
                      )}
                      {window.location.href.includes("account-reactivation") ? (
                        <div className="custom-col progressbarCol">
                          <div>
                            <div>
                              <ul className="progressbar">
                                {totalStage.map((stage, index) => {
                                  if (index !== 2) {
                                    if (currentStage - 1 >= index) {
                                      return (
                                        <li className="active">
                                          <span className="edel-icon-tick"></span>
                                        </li>
                                      );
                                    } else {
                                      return <li></li>;
                                    }
                                  }
                                })}
                              </ul>
                            </div>

                            <div>
                              <p className="field-subHead bold-text text-center">
                                {totalStage[currentStage - 1]}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : window.location.href.includes(
                          "address-modification"
                        ) ||
                        window.location.href.includes("bank-modification") ||
                        window.location.href.includes("segment-deactivation") ||
                        window.location.href.includes("segment-activation") ? (
                        <div className="custom-col">
                          <div className="mg-t35 space-mb-3">
                            <a
                              className="bold-text link-text"
                              onClick={(e: any) => {
                                e.preventDefault();
                                setStepsPopup(true);
                              }}
                            >
                              {getStepsHeader()}
                            </a>
                          </div>
                        </div>
                      ) : (
                        <div className="custom-col"></div>
                      )}
                    </div>
                    {stepsPopup && (
                      <StaticPopup
                        heading={getStepsHeader()}
                        content={getStepsContent()}
                        ShowPopup={setStepsPopup}
                      />
                    )}
                    {props.component && (
                      <props.component
                        onSubmit={handleSubmit}
                        srDropDown={(val: any) => setSrDropdown(val)}
                        ref={compDet}
                        loader={poaFlagLoader}
                        setLoader={setPOAFlagLoader}
                        setParLoader={setParentLoader}
                        parentLoader={parentLoader}
                        acntCategory={accountCategory}
                        enableSubmit={(val: any) => {
                          setEnableSubmit(val);
                        }}
                        showFooter={(val: any) => {
                          setShowFooter(val);
                        }}
                        setBtnText={(val: any) => {
                          setBtnText(val);
                        }}
                        stage={{ currentStage, setCurrentStage }}
                        rightDiv={setRightSideSec}
                        {...props}
                      />
                    )}
                  </div>
                  {(window.location.href.includes(
                    "email-mobile-modification"
                  ) ||
                    window.location.href.includes("nomination") ||
                    window.location.href.includes("fatcaUpdate") ||
                    window.location.href.includes("ckyc-update") ||
                    window.location.href.includes("income-declaration") ||
                    window.location.href.includes("account-closure")) &&
                    showFooter && (
                      <div
                        className={
                          "modal-footer common-modal--footer" +
                          (window.location.href.includes("nomination") ||
                          window.location.href.includes("account-closure")
                            ? " nomination-modal-footer"
                            : "")
                        }
                      >
                        <div className="mob-center">
                          <button
                            type="submit"
                            className="btn btn-blue login-btn pd-y10"
                            disabled={!enableSubmit}
                            onClick={(e: any) => {
                              onSubmit();
                              e.preventDefault();
                            }}
                          >
                            {btnText}
                          </button>
                          {!consentType?.includes("nominee") && (
                            <button
                              type="submit"
                              className="btn btn-olink login-btn"
                            >
                              <a
                                className="btn btn-olink login-btn"
                                href={
                                  RedirectnSource == "onep-sr"
                                    ? config.onePlatformBase + "service-request"
                                    : config.rootUrl +
                                      "clientarea/servicerequest"
                                }
                              >
                                Cancel
                              </a>
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                </form>
              }
            </div>
          </div>
        </>
      );
  }
  return (
    <EdModal
      show={showModel}
      modalClsNm={"modal-Sr"}
      close={() => {}}
      children={ModalBody()}
    />
  );
};
